import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`font-heading text-2xl whitespace-nowrap transition-colors ${
              isScrolled ? 'text-primary-500' : 'text-white'
            }`}
          >
            黑料吃瓜网
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="/"
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                isScrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              免费吃瓜入口
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl ${
                isScrolled ? 'text-foreground-900' : 'text-white'
              } ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/60 pb-4">
            <div className="flex flex-col gap-1 pt-3">
              <Link to="/" className="px-4 py-3 text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg text-sm font-medium transition-colors">
                首页
              </Link>
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-3 text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg text-sm font-medium transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="px-4 py-3 text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg text-sm font-medium transition-colors">
                关于我们
              </Link>
              <a
                href="/"
                className="mx-4 mt-2 py-3 text-center bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                免费吃瓜入口
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}